import React, { useState, useEffect } from "react";
import Logo from "../assets/logo.svg";
import Github from "../assets/Github.svg";
import Linkedin from "../assets/Linkedln.svg";
import Gmail from "../assets/Gmail.svg";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleScroll = () => {
    const isScrolled = window.scrollY > 0;
    setIsScrolled(isScrolled);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`tw-w-full tw-fixed tw-py-4 lg:tw-px-16 tw-transition-colors tw-duration-300 ${
        isScrolled || isMobileMenuOpen ? "tw-bg-gray-900" : ""
      }`}
    >
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-ml-6">
          <img src={Logo} alt="logo" />
        </div>
        <div className="tw-items-center tw-hidden tw-space-x-6 lg:tw-flex">
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="sobre-mim"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(0, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Sobre mim
          </Link>
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="skills"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(1000, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Skills
          </Link>
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="projetos"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(2000, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Projetos
          </Link>
        </div>
        <div className="tw-hidden lg:tw-flex tw-items-center tw-space-x-6">
          <a
            target="_blank"
            className="tw-cursor-pointer"
            href="https://github.com/pablokaue2004"
          >
            <img
              className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
              src={Github}
              alt=""
            />
          </a>
          <a
            target="_blank"
            className="tw-cursor-pointer"
            href="https://www.linkedin.com/in/pablo-kau%C3%AA-454180207/"
          >
            <img
              className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
              src={Linkedin}
              alt=""
            />
          </a>
          <a
            target="_blank"
            className="tw-cursor-pointer"
            href="mail:pablokauedev23@gmail.com"
          >
            <img
              className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
              src={Gmail}
              alt=""
            />
          </a>
        </div>
        <div className="tw-flex tw-px-8 tw-items-center lg:tw-hidden">
          <button
            className="tw-ml-4 focus:tw-outline-none"
            onClick={toggleMobileMenu}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="tw-w-6 tw-h-6 tw-text-white"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="tw-flex tw-flex-col tw-items-center tw-mt-4 lg:tw-hidden ">
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="sobre-mim"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(0, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Sobre mim
          </Link>
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="skills"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(1000, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Skills
          </Link>
          <Link
            className="tw-text-lg tw-font-normal tw-text-white tw-duration-200 tw-cursor-pointer hover:tw-font-bold"
            to="projetos"
            smooth={true}
            duration={500}
            onClick={() => {
              toggleMobileMenu();
              scroll.scrollTo(2000, {
                duration: 500,
                smooth: "easeInOutQuart",
              });
            }}
          >
            Projetos
          </Link>
          <div className="tw-flex tw-items-center tw-space-x-6">
            <a
              className="tw-cursor-pointer"
              href="https://github.com/pablokaue2004"
            >
              <img
                className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
                src={Github}
                alt=""
              />
            </a>
            <a
              className="tw-cursor-pointer"
              href="https://www.linkedin.com/in/pablo-kau%C3%AA-454180207/"
            >
              <img
                className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
                src={Linkedin}
                alt=""
              />
            </a>
            <a
              className="tw-cursor-pointer"
              href="mail:pablokauedev23@gmail.com"
            >
              <img
                className="tw-w-6 tw-duration-500 lg:tw-w-9 hover:tw-w-11"
                src={Gmail}
                alt=""
              />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
